<div class="filter-container">
  <mat-form-field>
    <mat-label>Companies</mat-label>
    <mat-select [(ngModel)]="selectedCompany" (selectionChange)="onCompanyChange(selectedCompany)">
      @for (company of companies; track company) {
      <mat-option [value]="company">{{company}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Year</mat-label>
    <mat-select [(ngModel)]="yearNumber" (selectionChange)="onYearChange()">
      @for (year of kpiYears; track year) {
      <mat-option [value]="year">{{year}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div>
  <table mat-table [dataSource]="kpisData">
    <!-- KPI Column -->
    <ng-container matColumnDef="KPI">
      <th mat-header-cell *matHeaderCellDef>KPI</th>
      <td mat-cell *matCellDef="let element">{{element.name}}</td>
    </ng-container>

    <!-- Tag Column -->
    <ng-container matColumnDef="Tag">
      <th mat-header-cell *matHeaderCellDef>Tag</th>
      <td mat-cell *matCellDef="let element">{{element.tag}}</td>
    </ng-container>

    <!-- Month Columns (Jan to Dec) -->
    <ng-container matColumnDef="Jan">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Jan-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 1 && isPastMonthForMenu(1)" (click)="startEditingForColumn(1)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 1 && isPastMonthForMenu(1)" (click)="approveKPIs(1)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 1" (click)="saveColumnChanges(1)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 1" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 1)" (click)="editCell(rowIndex)">

        <!-- Tooltip Wrapper -->
        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 1" class="static-cell">
            {{ getMonthValue(element, 1) !== null && getMonthValue(element, 1) !== undefined ? getMonthValue(element, 1)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 1" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 1) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 1) || element.isFormula }"
            (input)="onCellInput($event, element, 1)">
            {{ getMonthValue(element, 1) }}
          </div>

          <!-- Custom Tooltip -->
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 1)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(1)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 1)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 1)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button mat-menu-item style="margin-left: auto;" *ngIf="showLock"
                (click)="lockUnlockElement(element, false, 1)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Feb">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Feb-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 2 && isPastMonthForMenu(2)" (click)="startEditingForColumn(2)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 2 && isPastMonthForMenu(2)" (click)="approveKPIs(2)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>

            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 2" (click)="saveColumnChanges(2)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 2" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 2)" (click)="editCell(rowIndex)">

        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 2" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 2) !== null && getMonthValue(element, 2) !== undefined ? getMonthValue(element, 2)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 2" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 2) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 2) || element.isFormula }"
            (input)="onCellInput($event, element, 2)">
            {{ getMonthValue(element, 2) }}
          </div>

          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 2)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(2)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 2)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button *ngIf="!showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, true, 2)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 2)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Mar">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Mar-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 3 && isPastMonthForMenu(3)" (click)="startEditingForColumn(3)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 3 && isPastMonthForMenu(3)" (click)="approveKPIs(3)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 3" (click)="saveColumnChanges(3)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 3" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>

      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 3)" (click)="editCell(rowIndex)">

        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 3" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 3) !== null && getMonthValue(element, 3) !== undefined ? getMonthValue(element, 3)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 3" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 3) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 3) || element.isFormula }"
            (input)="onCellInput($event, element, 3)">
            {{ getMonthValue(element, 3) }}
          </div>

          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 3)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(3)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
              (click)="getLockedInfo(element, 3)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 3)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 3)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Apr">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Apr-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 4 && isPastMonthForMenu(4)" (click)="startEditingForColumn(4)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 4 && isPastMonthForMenu(4)" (click)="approveKPIs(4)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 4" (click)="saveColumnChanges(4)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 4" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>

      <td mat-cell *matCellDef="let element; let rowIndex = index;" class="table-cell" [ngClass]="getClass(element, 4)" (click)="editCell(rowIndex)">
        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 4" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 4) !== null && getMonthValue(element, 4) !== undefined ? getMonthValue(element, 4)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 4" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 4) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 4) || element.isFormula }"
            (input)="onCellInput($event, element, 4)">
            {{ getMonthValue(element, 4) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 4)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(4)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 4)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 4)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 4)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="May">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>May-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 5 && isPastMonthForMenu(5)" (click)="startEditingForColumn(5)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 5" (click)="approveKPIs(5)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 5" (click)="saveColumnChanges(5)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 5" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>

      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 5)" (click)="editCell(rowIndex)">

        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 5" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 5) !== null && getMonthValue(element, 5) !== undefined ? getMonthValue(element, 5)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 5" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 5) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 5) || element.isFormula }"
            (input)="onCellInput($event, element, 5)">
            {{ getMonthValue(element, 5) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 5)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(5)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 5)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 5)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 5)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Jun">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Jun-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 6 && isPastMonthForMenu(6)" (click)="startEditingForColumn(6)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 6 && isPastMonthForMenu(6)" (click)="approveKPIs(6)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 6" (click)="saveColumnChanges(6)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 6" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>

      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 6)" (click)="editCell(rowIndex)">

        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 6" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 6) !== null && getMonthValue(element, 6) !== undefined ? getMonthValue(element, 6)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 6" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 6) && !element.isFormula? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 6) || element.isFormula }"
            (input)="onCellInput($event, element, 6)">
            {{ getMonthValue(element, 6) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 6)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(6)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 6)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 6)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 6)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Jul">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Jul-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 7 && isPastMonthForMenu(7)" (click)="startEditingForColumn(7)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 7 && isPastMonthForMenu(7)" (click)="approveKPIs(7)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 7" (click)="saveColumnChanges(7)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 7" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>

      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 7)" (click)="editCell(rowIndex)">

        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 7" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 7) !== null && getMonthValue(element, 7) !== undefined ? getMonthValue(element, 7)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 7" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 7) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 7) || element.isFormula }"
            (input)="onCellInput($event, element, 7)">
            {{ getMonthValue(element, 7) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 7)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(7)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 7)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 7)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 7)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Aug">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Aug-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 8 && isPastMonthForMenu(8)" (click)="startEditingForColumn(8)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 8 && isPastMonthForMenu(8)" (click)="approveKPIs(8)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 8" (click)="saveColumnChanges(8)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 8" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 8)" (click)="editCell(rowIndex)">
        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 8" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 8) !== null && getMonthValue(element, 8) !== undefined ? getMonthValue(element, 8)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 8" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 8) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 8) || element.isFormula }"
            (input)="onCellInput($event, element, 8)">
            {{ getMonthValue(element, 8) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 8)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(8)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 8)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 8)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 8)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Sep">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Sep-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 9 && isPastMonthForMenu(9)" (click)="startEditingForColumn(9)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 9 && isPastMonthForMenu(9)" (click)="approveKPIs(9)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 9" (click)="saveColumnChanges(9)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 9" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>

      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 9)" (click)="editCell(rowIndex)">
        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 9" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 9) !== null && getMonthValue(element, 9) !== undefined ? getMonthValue(element, 9)
            :
            '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 9" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 9) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 9) || element.isFormula }"
            (input)="onCellInput($event, element, 9)">
            {{ getMonthValue(element, 9) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 9)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(9)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 9)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 9)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 9)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Oct">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Oct-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 10 && isPastMonthForMenu(10)" (click)="startEditingForColumn(10)" class="material-symbols-outlined"
              matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 10 && isPastMonthForMenu(10)" (click)="approveKPIs(10)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 10" (click)="saveColumnChanges(10)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 10" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 10)" (click)="editCell(rowIndex)">
        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 10" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 10) !== null && getMonthValue(element, 10) !== undefined ? getMonthValue(element,
            10)
            : '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 10" class="input-cell"
            [attr.contenteditable]="!getLockedInfo(element, 10) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 10) || element.isFormula }"
            (input)="onCellInput($event, element, 10)">
            {{ getMonthValue(element, 10) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 10)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(10)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 10)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 10)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 10)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Nov">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Nov-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 11 && isPastMonthForMenu(11)" (click)="startEditingForColumn(11)"
              class="material-symbols-outlined" matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 11 && isPastMonthForMenu(11)" (click)="approveKPIs(11)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 11" (click)="saveColumnChanges(11)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 11" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>

      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 11)" (click)="editCell(rowIndex)">
        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 11" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 11) !== null && getMonthValue(element, 11) !== undefined ? getMonthValue(element,
            11)
            : '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 11" class="input-cell"
            [attr.contenteditable]="!this.getLockedInfo(element, 11) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input': getLockedInfo(element, 11) || element.isFormula }"
            (input)="onCellInput($event, element, 11)">
            {{ getMonthValue(element, 11) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 11)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(11)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 11)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 11)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 11)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Dec">
      <th mat-header-cell *matHeaderCellDef class="month-header">
        <div class="header-wrapper">
          <!-- Month Name -->
          <span>Dec-{{ selectedYear.slice(-2) }}</span>

          <!-- Action Buttons -->
          <div class="header-actions">
            <!-- Edit -->
            <span *ngIf="editingColumnIndex !== 12 && isPastMonthForMenu(12)" (click)="startEditingForColumn(12)"
              class="material-symbols-outlined" matTooltip="Edit">
              edit
            </span>
            <!-- Approve -->
            <span *ngIf="editingColumnIndex != 12 && isPastMonthForMenu(12)" (click)="approveKPIs(12)" class="material-symbols-outlined" matTooltip="Approve">
              check_circle
            </span>
            <!-- Save and Cancel -->
            <span *ngIf="editingColumnIndex === 12" (click)="saveColumnChanges(12)" class="material-symbols-outlined"
              matTooltip="Save">
              save
            </span>
            <span *ngIf="editingColumnIndex === 12" (click)="cancelColumnEditing()" class="material-symbols-outlined"
              matTooltip="Cancel">
              cancel
            </span>
          </div>
        </div>
      </th>

      <td mat-cell *matCellDef="let element; let rowIndex = index" class="table-cell" [ngClass]="getClass(element, 12)" (click)="editCell(rowIndex)">

        <div class="tooltip-wrapper">
          <!-- Static cell when not editing -->
          <div *ngIf="editingColumnIndex !== 12" class="static-cell">
            <!-- Display 0 correctly for static cells -->
            {{ getMonthValue(element, 12) !== null && getMonthValue(element, 12) !== undefined ? getMonthValue(element,
            12)
            : '0' }}
          </div>

          <!-- Editable cell when in editing mode -->
          <div *ngIf="editingColumnIndex === 12" class="input-cell"
            [attr.contenteditable]="!this.getLockedInfo(element, 12) && !element.isFormula ? 'true' : null"
            [ngClass]="{ 'disabled-input':  element.isFormula || this.getLockedInfo(element, 12) }"
            (input)="onCellInput($event, element, 12)">
            {{ getMonthValue(element, 12) }}
          </div>
          <span *ngIf="!isEditing" class="custom-tooltip" [innerHTML]="getTooltipText(element, 12)"></span>
          <div *ngIf="isCurrentUserAdmin && !element.isFormula && !isEditing && isPastMonthForMenu(12)">
            <span mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options menu"
              (click)="getLockedInfo(element, 12)">
              <mat-icon style="font-size: 20px; opacity: 0.6; color: rgba(0, 0, 0, 0.6);">more_vert</mat-icon>
            </span>
            <mat-menu #menu="matMenu">
              <button mat-menu-item style="margin-left: auto;" *ngIf="!showLock"
                (click)="lockUnlockElement(element, true, 12)">
                <mat-icon>lock</mat-icon>
                <span>Lock</span>
              </button>
              <button *ngIf="showLock" mat-menu-item style="margin-left: auto;"
                (click)="lockUnlockElement(element, false, 12)">
                <mat-icon>lock_open</mat-icon>
                <span>Unlock</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Header and Data Rows -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ 'bold-row': row.isFormula }"></tr>
  </table>
  <!-- No data message -->
  <div *ngIf="!isLoading && kpisData.length === 0" class="no-data-message">
    No data available
  </div>
</div>
<div class="loading-overlay" *ngIf="isLoading">
  <mat-spinner diameter="50"></mat-spinner>
</div>
<div class="spacing-div">

</div>

